import { render } from "./app-icon-fpx.vue?vue&type=template&id=64d6e67d"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-fpx.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64d6e67d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64d6e67d', __exports__)) {
    console.log('reload')
    api.reload('64d6e67d', __exports__)
  }
  
  module.hot.accept("./app-icon-fpx.vue?vue&type=template&id=64d6e67d", () => {
    console.log('re-render')
    api.rerender('64d6e67d', render)
  })

}


export default __exports__